//@flow
// import { Platform } from "react-native";

let DeviceType = {
  IS_SMARTPHONE_OR_TABLET: true, // Platform.OS !== "web"
};

export { DeviceType };